var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
export const Container = props => {
    const { as, children, className, size = 'md' } = props, rest = __rest(props, ["as", "children", "className", "size"]);
    const sizeClsx = {
        'max-w-8xl ': size === 'md',
        'max-w-3xl': size === 'sm',
    };
    const Component = as || 'div';
    return (React.createElement(Component, Object.assign({ className: clsx(sizeClsx, 'mx-auto sm:px-6 lg:px-8', className) }, rest), children));
};
//# sourceMappingURL=Container.js.map